export default class faqPreManager {
  constructor() {
    // 遷移前のページによってヘッダーを切り替える
    let id;
    const param = this.getParam('select');
    switch (param) {
      case 'fryingpan':
      case 'ricepot':
      case 'ovenpotround':
        id = param;
        break;
      default:
        id = 'default';
        break;
    }
    Array.prototype.forEach.call(
      document.querySelectorAll(`.faq-header:not(.faq-header--${id})`),
      (el, i) => {
        el.innerHTML = '';
      }
    );
  }

  getParam(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
}
